module.exports = __webpack_public_path__ + "img/774-32d2fa.png";